/**
 * @author      luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright   Copyright (c) 20245, Zumper
 * @description inactive save search modal reducer
 */

import { alwaysReducer, payloadReducer } from '@zcode/reducers'
import type { InactiveSaveSearchModal } from '@zcode/state-type'
import { handleActions } from 'redux-actions'
import { CLEAR_DATA, RECEIVE_DATA } from '../constants/inactiveSaveSearchModal'
import type { ActionTypes } from '../types'

const DEFAULT_STATE = {
  origin: undefined,
  selectedFloorplan: null,
} as const satisfies InactiveSaveSearchModal

export const inactiveSaveSearchReducer = handleActions<InactiveSaveSearchModal, ActionTypes>(
  {
    [CLEAR_DATA]: alwaysReducer(DEFAULT_STATE),
    [RECEIVE_DATA]: payloadReducer,
  },
  DEFAULT_STATE
)
